import {createSlice} from "@reduxjs/toolkit"

export const ContentSlice = createSlice({
    name:'Content Slice',
    initialState:{
        coachers:null,
        slides:null,
        price:null
    },
    reducers:{
        chat_info:(state,action)=>{
           state.coachers = action.payload
           state.slides = action.payload
           state.price = action.payload
        }
    }
})

export const {coachers,slides,price} = ContentSlice.actions

export default ContentSlice.reducer